export const defaultRequestHeaders = {
  "Content-Type": "application/json",
};

export type defaultGraphsGetFiltersType = {

}

export type defaultAPIsResponseType = {
  message?: string,
  total: number,
  data: any | defaultGraphsDataType,
}

export type defaultGraphsDataType = {
  total: number,
  page?: number,
  data: any[],
}

export interface FetchDashboardDataParams {
  filters: any;
}


export const ADMIN_APP_TYPES = {
  ADMIN: "admin",
  MANAGER: "manager",
  SUPER_ADMIN: "super_admin",
} as const;

export const adminAppsTypes = [
  ADMIN_APP_TYPES.ADMIN,
  ADMIN_APP_TYPES.MANAGER,
  ADMIN_APP_TYPES.SUPER_ADMIN,
] as const;

export type adminAppsTypesType = typeof adminAppsTypes[number];